module.exports = __webpack_public_path__ + "img/banana-mobile-bk.d5b5a395.svg";